module.exports = __webpack_public_path__ + "static/media/icon_suppository.7019144f.svg";